import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";

const Ctx = createContext(null);
const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
const KEY = "odf_cliente_token";

export function ClienteAuthProvider({ children }) {
  const [cliente, setCliente] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem(KEY));
  const [loading, setLoading] = useState(true);

  const api = useMemo(() => {
    const i = axios.create({ baseURL: API_BASE });
    i.interceptors.request.use((c) => {
      if (token) c.headers.Authorization = `Bearer ${token}`;
      return c;
    });
    i.interceptors.response.use(
      (r) => r,
      (e) => {
        if (e.response?.status === 401) {
          setCliente(null); setToken(null); localStorage.removeItem(KEY);
        }
        return Promise.reject(e);
      }
    );
    return i;
  }, [token]);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    api.get("/api/portal/me")
      .then((r) => setCliente(r.data))
      .catch(() => { setToken(null); localStorage.removeItem(KEY); })
      .finally(() => setLoading(false));
  }, [token, api]);

  const loginWithToken = useCallback((t) => {
    localStorage.setItem(KEY, t);
    setToken(t);
  }, []);

  const logout = useCallback(() => {
    setCliente(null); setToken(null); localStorage.removeItem(KEY);
  }, []);

  const refresh = useCallback(() => {
    api.get("/api/portal/me").then((r) => setCliente(r.data)).catch(() => {});
  }, [api]);

  return (
    <Ctx.Provider value={{ cliente, token, loading, api, loginWithToken, logout, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export const useClienteAuth = () => useContext(Ctx);
